export const QUALIFICATION_OPTIONS = [
    'B.E',
    'B.Tech',
    'M.E',
    'M.Tech',
    'MS',
    'ME',
    'B.Sc'
];

export const BRANCH_OPTIONS = [
    'ECE',
    'EEE',
    'EE',
    'EIE',
    'E&TC',
    'ESYS',
    'VLSI',
    'CSE',
    'IT',
    'AIML',
    'DATA SCIENCE',
    'CYBER SECURITY',
    'IOT',
    'COMPUTERS',
    'POWER SYSTEMS',
    'ELECTRONICS',
    'MECHATRONICS'
];

export const getYearOfPassingOptions = () => {
    const currentYear = new Date().getFullYear();
    return [
        ...Array.from({ length: 3 }, (_, index) => String(currentYear - 3 + index)),
        String(currentYear),
        ...Array.from({ length: 3 }, (_, index) => String(currentYear + index + 1)),
        'Other'
    ];
};

export const EMPTY_ELIGIBILITY_RESTRICTIONS = {
    qualification: { enabled: false, allowedValues: [] },
    branch: { enabled: false, allowedValues: [] },
    yop: { enabled: false, allowedValues: [] },
    state: { enabled: false, allowedValues: [] }
};

export const parseEligibilityRestrictions = (value) => {
    let parsed = value;
    if (typeof value === 'string') {
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            parsed = {};
        }
    }

    return Object.keys(EMPTY_ELIGIBILITY_RESTRICTIONS).reduce((result, key) => {
        const restriction = parsed && parsed[key];
        result[key] = {
            enabled: restriction?.enabled === true,
            allowedValues: Array.isArray(restriction?.allowedValues)
                ? [...new Set(restriction.allowedValues.map(String).map(option => option.trim()).filter(Boolean))]
                : []
        };
        return result;
    }, {});
};

export const getRestrictedOptions = (allOptions, restriction) => (
    restriction?.enabled
        ? allOptions.filter(option => restriction.allowedValues.includes(option))
        : allOptions
);
